import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LinearProgress } from 'react-md';

// Import styling
import '../../styles/ListItem.css';

class ListItem extends Component {
	render() {
		return (
			<li className="ListItem">
				<div className="label">
					{this.props.label}
					{/* Compare progress against others in the list */}
					{/* <Progress min={this.props.min} max={this.props.max} value={this.props.value} /> */}
					<LinearProgress
						style={{
							boxShadow:
								'inset 0 0 0px #2196F1, inset 0px 0 0px #2196f3, inset 0px 0 0px #2196f3, inset 0px 0 0px #122d42, inset 0px 0 0px #2196F3, 0 0 5px #2196F1, 5px 0 30px #2196f3, 0px 0 10px #2196F3',
							height: '4px',
							borderRadius: '5px',
						}}
						value={Number(this.props.value)}
					/>
				</div>
				<div>
					<div className="value">{this.props.value}%</div>
				</div>
			</li>
		);
	}
}

// Enforce the type of props to send to this component
ListItem.propTypes = {
	label: PropTypes.string,
	min: PropTypes.number,
	max: PropTypes.number,
	value: PropTypes.number,
};

export default ListItem;
